import { CurrentConfigContext } from "@/app/app.utils";
import { isCfaFeatureFlagEnabled } from "@/app/_helpers/permissions";
import { useContext } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Pathways Milestone 3 copy/features (e.g. "My Assessments" rename).
 * Enabled via CFA feature flag or `?isPathwaysMilestone3=true`.
 */
export const useIsPathwaysMilestone3 = (): boolean => {
  const config = useContext(CurrentConfigContext);
  const [searchParams] = useSearchParams();

  return (
    Boolean(
      isCfaFeatureFlagEnabled("roofdog_is_pathways_milestone3", config),
    ) || searchParams.get("isPathwaysMilestone3") === "true"
  );
};
